<template>
  <div>
    <div class="dataTime">
      <span class="demonstration">{{$t('DriverAnalysis.date')}}</span>
      <el-date-picker
        v-model="changeValue"
        value-format="yyyy-MM-dd"
        type="daterange"
        :range-separator="$t('common.to')"
        :start-placeholder="$t('common.starDate')"
        :end-placeholder="$t('common.endDate')"
        @change="changeTime"
      >
      </el-date-picker>
    </div>
    <div class="dataEchart">
      <div class="dataUse">{{$t('DriverAnalysis.dayUseRate')}}</div>
      <el-tabs v-model="activeSelect" @tab-click="handleClick">
        <el-tab-pane :label="$t('DriverAnalysis.twentyFourHourSystem')" name="first">
          <div v-if="'first' == activeSelect">
            <linegraph
              v-loading="dayLoading"
              :id="'dayBargraph'"
              :data="dayOption"
              style="height: 313px"
            ></linegraph>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('DriverAnalysis.eightHourSystem')" name="second">
          <div v-if="'second' == activeSelect">
            <linegraph
              v-loading="dayLoading"
              :id="'dayBargraph'"
              :data="dayOption"
              style="height: 313px"
            ></linegraph>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="dataTable">
      <el-tabs v-model="activeName" @tab-click="handleChange">
        <el-tab-pane :label="$t('DriverAnalysis.driverWorkCollect')" name="first">
          <div v-if="'first' == activeName">
            <div class="rightAll-btn" style="float: right">
              <el-button v-if="isPrimaryKey('DRIVERANALYSIS_DRIVERDURATION_CHANGE_DRIVERWORKCOLLECT_DOWN')" type="text" @click="downCar"
                >{{$t('common.btn.download')}}</el-button
              >
            </div>
            <i-table
              :list="list"
              ref="carTable"
              @handleSelectionChange="handleSelectionChange"
              :options="option"
              :columns="columns"
              :operates="operates"
            ></i-table>
            <IPagination ref="page" @PageFun="changeSize"></IPagination>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('DriverAnalysis.driverWorkRecord')" name="second">
          <div v-if="'second' == activeName">
            <div class="rightAll-btn" style="float: right">
              <el-button v-if="isPrimaryKey('DRIVERANALYSIS_DRIVERDURATION_CHANGE_DRIVERWORKRECORD_DOWN')" type="text" @click="downRecord">{{$t('common.btn.download')}}</el-button>
            </div>
            <i-table
              :list="driveList"
              ref="carTable"
              @handleSelectionChange="handleSelection"
              :options="option"
              :columns="Columns"
              :operates="operates"
            ></i-table>
            <IPagination
              ref="drivePage"
              @PageFun="changeDriveSize"
            ></IPagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ChangeTime from "./ChangeTime";
export default ChangeTime;
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
</style>
